import { Property as P } from 'csstype';
import { reduce, concat, defaults } from 'lodash';

export type Grays = {
    100: P.Color,
    200: P.Color,
    300: P.Color,
    400: P.Color,
    500: P.Color,
    600: P.Color,
    700: P.Color,
    800: P.Color,
    900: P.Color,
}

export type Colors = {
    blue: P.Color,
    indigo: P.Color,
    purple: P.Color,
    pink: P.Color,
    red: P.Color,
    orange: P.Color,
    yellow: P.Color,
    green: P.Color,
    teal: P.Color,
    cyan: P.Color,
    white: P.Color,
    gray: P.Color,
    grayDark: P.Color
}

export type ThemeColors = {
    primary: P.Color,
    secondary: P.Color,
    success: P.Color,
    info: P.Color,
    warning: P.Color,
    danger: P.Color,
    light: P.Color,
    dark: P.Color
}

export type Spacer = P.Padding | P.Margin;
export type Spacers = Spacer[];

export type Size = P.Height | P.Width;
export type Sizes = {
    25: Size,
    50: Size,
    75: Size,
    100: Size,
    auto: Size
}

export type GridBreakPoints = {
    xs: P.Width,
    sm: P.Width,
    md: P.Width,
    lg: P.Width,
    xl: P.Width,
    xxl: P.Width
}

export type ContainerMaxWidths = {
    sm: P.Width,
    md: P.Width,
    lg: P.Width,
    xl: P.Width,
    xxl: P.Width
}

export type EmbedResponsiveAspectRatio = { x: Number, y: Number };

export type EmbedResponsiveAspectRatios = EmbedResponsiveAspectRatio[];

export type Theme = {
    // Color system

    white: P.Color,
    gray100: P.Color,
    gray200: P.Color,
    gray300: P.Color,
    gray400: P.Color,
    gray500: P.Color,
    gray600: P.Color,
    gray700: P.Color,
    gray800: P.Color,
    gray900: P.Color,
    black: P.Color,

    grays: Grays,

    blue: P.Color,
    indigo: P.Color,
    purple: P.Color,
    pink: P.Color,
    red: P.Color,
    orange: P.Color,
    yellow: P.Color,
    green: P.Color,
    teal: P.Color,
    cyan: P.Color,

    colors: Colors,

    primary: P.Color,
    secondary: P.Color,
    success: P.Color,
    info: P.Color,
    warning: P.Color,
    danger: P.Color,
    light: P.Color,
    dark: P.Color,

    themeColors: ThemeColors,

    //themeColorInterval: Number,
    //    // Options
    ////
    //// Quickly modify global styling by enabling or disabling optional features.

    //$enable - caret: true!default ,
    //$enable - rounded: true!default ,
    //$enable - shadows: false!default ,
    //$enable - gradients: false!default ,
    //$enable - transitions: true!default ,
    //$enable - prefers - reduced - motion - media - query: true!default ,
    //$enable - hover - media - query: false!default , // Deprecated, no longer affects any compiled CSS
    //$enable - grid - classes: true!default ,
    //$enable - pointer - cursor -for-buttons: true!default ,
    //$enable - print - styles: true!default ,
    //$enable - responsive - font - sizes: false!default ,
    //$enable - validation - icons: true!default ,
    //$enable - deprecation - messages: true!default ,




    //// Spacing
    ////
    //// Control the default styling of most Bootstrap elements by modifying these
    //// variables. Mostly focused on spacing.
    //// You can add more entries to the $spacers map, should you need more variation.

    //$spacer: 1rem!default ,
    //$spacers: ()!default ,
    //$spacers: map - merge(
    //    (
    //        0: 0,
    //    1: ($spacer * .25),
    //    2: ($spacer * .5),
    //    3: $spacer,
    //    4: ($spacer * 1.5),
    //    5: ($spacer * 3)
    //),
    //    $spacers
    //),
    spacer: Spacer,
    spacers: Spacers,

    //// This variable affects the `.h-*` and `.w-*` classes.
    //$sizes: ()!default ,
    //$sizes: map - merge(
    //    (
    //        25: 25 %,
    //    50: 50 %,
    //    75: 75 %,
    //    100: 100 %,
    //    auto: auto
    //),
    //    $sizes
    //),
    sizes: Sizes,

    //// Body
    ////
    //// Settings for the `<body>` element.

    //$body - bg: $white!default ,
    //$body - color: $gray - 900!default ,
    bodyBg: P.BackgroundColor,
    bodyColor: P.Color,
    //// Links
    ////
    //// Style anchor elements.
    linkColor: P.Color,
    linkDecoration: P.TextDecoration,
    linkHoverColor: P.Color,
    linkHoverDecoration: P.TextDecoration,
    //// Darken percentage for links with `.text-*` class (e.g. `.text-success`)
    //emphasizedLinkHoverDarkenPercentage: Number


    //    // Paragraphs
    //    //
    //    // Style p element.

    //    $paragraph- margin - bottom:   1rem!default ,
    paragraphMarginBottom: P.MarginBottom,

    //// Grid breakpoints
    ////
    //// Define the minimum dimensions at which your layout will change,
    //// adapting to different screen sizes, for use in media queries.

    //$grid - breakpoints: (
    //    xs: 0,
    //    sm: 576px,
    //    md: 768px,
    //    lg: 992px,
    //    xl: 1200px
    //) !default ,
    gridBreakPoints: GridBreakPoints,

    //@include _assert - ascending($grid - breakpoints, "$grid-breakpoints"),
    //@include _assert - starts - at - zero($grid - breakpoints, "$grid-breakpoints"),


    //// Grid containers
    ////
    //// Define the maximum width of `.container` for different screen sizes.

    //$container - max - widths: (
    //    sm: 540px,
    //    md: 720px,
    //    lg: 960px,
    //    xl: 1140px
    //) !default ,
    containerMaxWidths: ContainerMaxWidths,

    //@include _assert - ascending($container - max - widths, "$container-max-widths"),


    //// Grid columns
    ////
    //// Set the number of columns and specify the width of the gutters.

    //$grid - columns: 12!default ,
    //$grid - gutter - width: 30px!default ,
    //$grid - row - columns: 6!default ,
    //    gridColumns: Number,


    //// Components
    ////
    //// Define common padding and border radius sizes and more.

    //$line - height - lg: 1.5!default ,
    //$line - height - sm: 1.5!default ,
    lineHeightLg: P.LineHeight,
    lineHeightSm: P.LineHeight,

    //$border - width: 1px!default ,
    //$border - color: $gray - 300!default ,
    borderWidth: P.BorderWidth,
    borderColor: P.BorderColor,

    //$border - radius: .25rem!default ,
    //$border - radius - lg: .3rem!default ,
    //$border - radius - sm: .2rem!default ,
    borderRadius: P.BorderRadius,
    borderRadiusLg: P.BorderRadius,
    borderRadiusSm: P.BorderRadius,

    //$rounded - pill: 50rem!default ,
    rounderPill: P.BorderRadius,

    //$box - shadow - sm: 0 .125rem .25rem rgba($black, .075)!default ,
    //$box - shadow: 0 .5rem 1rem rgba($black, .15)!default ,
    //$box - shadow - lg: 0 1rem 3rem rgba($black, .175)!default ,
    boxShadowSm: P.BoxShadow,
    boxShadow: P.BoxShadow,
    boxShadowLg: P.BoxShadow,


    //$component - active - color: $white!default ,
    //$component - active - bg: theme - color("primary")!default ,
    componentActiveColor: P.Color,
    componentActiveBg: P.BackgroundColor,

    //$caret - width: .3em!default ,
    //$caret - vertical - align: $caret - width * .85!default ,
    //$caret - spacing: $caret - width * .85!default ,
    caretWidth: P.BorderWidth,
    caretVerticalAlign: P.VerticalAlign,
    caretSpacing: P.MarginLeft,

    //$transition - base: all .2s ease -in -out!default ;
    //$transition - fade: opacity .15s linear!default ;
    //$transition - collapse: height .35s ease!default ;
    transitionBase: P.Transition,
    transitionFade: P.Transition,
    transitionCollapse: P.Transition,

    //$embed - responsive - aspect - ratios: ()!default ;
    //$embed - responsive - aspect - ratios: join(
    //    (
    //        (21 9),
    //    (16 9),
    //(4 3),
    //(1 1),
    //  ),
    //$embed - responsive - aspect - ratios
    //);
    embedResponsiveAspectRatios: EmbedResponsiveAspectRatios,

    // Typography
    //
    // Font, line-height, and color for body text, headings, and more.

    fontFamilySansSerif: P.FontFamily,
    //fontFamilySerif: P.FontFamily,
    fontFamilyMonospace: P.FontFamily,
    fontFamilyBase: P.FontFamily,

    fontSizeBase: P.FontSize,
    fontSizeLarge: P.FontSize,
    fontSizeSmall: P.FontSize,

    fontWeightLighter: P.FontWeight,
    fontWeightLight: P.FontWeight,
    fontWeightNormal: P.FontWeight,
    fontWeightBold: P.FontWeight,
    fontWeightBolder: P.FontWeight,

    fontWeightBase: P.FontWeight,
    lineHeightBase: P.LineHeight,

    h1FontSize: P.FontSize,
    h2FontSize: P.FontSize,
    h3FontSize: P.FontSize,
    h4FontSize: P.FontSize,
    h5FontSize: P.FontSize,
    h6FontSize: P.FontSize,

    headingsMarginBottom: P.MarginBottom,
    headingsFontFamily: P.FontFamily,
    headingsFontWeight: P.FontWeight,
    headingsLineHeight: P.LineHeight,
    headingsColor: P.Color,

    display1Size: P.FontSize,
    display2Size: P.FontSize,
    display3Size: P.FontSize,
    display4Size: P.FontSize,

    display1Weight: P.FontWeight,
    display2Weight: P.FontWeight,
    display3Weight: P.FontWeight,
    display4Weight: P.FontWeight,
    displayLineHeight: P.LineHeight,



    /*
     // Navs

$nav-link-padding-y:                .5rem !default;
$nav-link-padding-x:                1rem !default;
$nav-link-disabled-color:           $gray-600 !default;

$nav-tabs-border-color:             $gray-300 !default;
$nav-tabs-border-width:             $border-width !default;
$nav-tabs-border-radius:            $border-radius !default;
$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;
$nav-tabs-link-active-color:        $gray-700 !default;
$nav-tabs-link-active-bg:           $body-bg !default;
$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;

$nav-pills-border-radius:           $border-radius !default;
$nav-pills-link-active-color:       $component-active-color !default;
$nav-pills-link-active-bg:          $component-active-bg !default;

$nav-divider-color:                 $gray-200 !default;
$nav-divider-margin-y:              $spacer / 2 !default;
     
     */

    navTabsBorderColor: P.BorderColor;
    navTabsBorderWidth: P.BorderWidth;
    navTabsBorderRadius: P.BorderRadius;
    navTabsLinkHoverBorderColor: P.BorderColor;
    navTabsLinkActiveColor: P.Color;
    navTabsLinkActiveBg: P.BackgroundColor;
    navTabsLinkActiveBorderColor: P.BorderColor;
}

type DynamicPoperty<T> = T | ((theme:Theme) => T);

export type ThemeBase = {
    [k in keyof Theme]: Theme[k] | DynamicPoperty<Theme[k]>;
}

export type ThemePartial = Partial<ThemeBase>;

const handler = {
    get: (target: ThemeBase, property: keyof Theme, receiver: Theme) => {

        let prop = target[property];

        return (prop instanceof Function) ? prop(receiver) : prop;
    }
};

export const makeTheme = (base: ThemeBase, partials: ThemePartial | ThemePartial[] = [] as ThemePartial[]): Theme => {
    let theme = reduce(concat(partials, base), defaults, {} as ThemePartial) as ThemeBase;

    return new Proxy(theme, handler) as Theme;
}